module.exports = __webpack_public_path__ + "static/img/head3.2443293.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head3.png
// module id = 44UH
// module chunks = 1